module.exports = __webpack_public_path__ + "img/sort.0f7520d5.jpg";